export interface Airport {
  code: string;
  name: string;
  city: string;
  state: string;
  lat: number;
  lng: number;
}

export const majorAirports: Airport[] = [
  // California
  { code: "LAX", name: "Los Angeles International", city: "Los Angeles", state: "CA", lat: 33.9416, lng: -118.4085 },
  { code: "SFO", name: "San Francisco International", city: "San Francisco", state: "CA", lat: 37.6213, lng: -122.3790 },
  { code: "SAN", name: "San Diego International", city: "San Diego", state: "CA", lat: 32.7338, lng: -117.1933 },
  { code: "SJC", name: "San Jose International", city: "San Jose", state: "CA", lat: 37.3626, lng: -121.9291 },
  { code: "OAK", name: "Oakland International", city: "Oakland", state: "CA", lat: 37.7213, lng: -122.2208 },
  
  // Texas
  { code: "DFW", name: "Dallas Fort Worth International", city: "Dallas", state: "TX", lat: 32.8998, lng: -97.0403 },
  { code: "IAH", name: "George Bush Intercontinental", city: "Houston", state: "TX", lat: 29.9844, lng: -95.3414 },
  { code: "AUS", name: "Austin-Bergstrom International", city: "Austin", state: "TX", lat: 30.1945, lng: -97.6699 },
  { code: "SAT", name: "San Antonio International", city: "San Antonio", state: "TX", lat: 29.5337, lng: -98.4698 },
  
  // New York/New Jersey
  { code: "JFK", name: "John F. Kennedy International", city: "New York", state: "NY", lat: 40.6413, lng: -73.7781 },
  { code: "EWR", name: "Newark Liberty International", city: "Newark", state: "NJ", lat: 40.6895, lng: -74.1745 },
  { code: "LGA", name: "LaGuardia Airport", city: "New York", state: "NY", lat: 40.7769, lng: -73.8740 },
  
  // Pennsylvania
  { code: "PHL", name: "Philadelphia International", city: "Philadelphia", state: "PA", lat: 39.8729, lng: -75.2437 },
  
  // Washington DC
  { code: "DCA", name: "Ronald Reagan Washington National", city: "Washington", state: "DC", lat: 38.8521, lng: -77.0377 },
  { code: "IAD", name: "Washington Dulles International", city: "Washington", state: "VA", lat: 38.9531, lng: -77.4565 },
  
  // Florida
  { code: "MIA", name: "Miami International", city: "Miami", state: "FL", lat: 25.7959, lng: -80.2870 },
  { code: "MCO", name: "Orlando International", city: "Orlando", state: "FL", lat: 28.4312, lng: -81.3081 },
  { code: "FLL", name: "Fort Lauderdale-Hollywood International", city: "Fort Lauderdale", state: "FL", lat: 26.0742, lng: -80.1506 },
  { code: "TPA", name: "Tampa International", city: "Tampa", state: "FL", lat: 27.9755, lng: -82.5332 },
  
  // Illinois
  { code: "ORD", name: "O'Hare International", city: "Chicago", state: "IL", lat: 41.9742, lng: -87.9073 },
  { code: "MDW", name: "Midway International", city: "Chicago", state: "IL", lat: 41.7868, lng: -87.7522 },
  
  // Ohio
  { code: "CLE", name: "Cleveland Hopkins International", city: "Cleveland", state: "OH", lat: 41.4117, lng: -81.8498 },
  { code: "CMH", name: "John Glenn Columbus International", city: "Columbus", state: "OH", lat: 39.9980, lng: -82.8919 },
  
  // Michigan
  { code: "DTW", name: "Detroit Metropolitan Wayne County", city: "Detroit", state: "MI", lat: 42.2162, lng: -83.3554 },
];

// Haversine formula to calculate distance between two points
export function calculateDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 3959; // Earth's radius in miles
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  
  return Math.round(distance);
}

export function findNearestAirport(venueLat: number, venueLng: number): {
  airport: Airport;
  distance: number;
} {
  let nearest = majorAirports[0];
  let minDistance = calculateDistance(venueLat, venueLng, nearest.lat, nearest.lng);
  
  for (const airport of majorAirports) {
    const distance = calculateDistance(venueLat, venueLng, airport.lat, airport.lng);
    if (distance < minDistance) {
      minDistance = distance;
      nearest = airport;
    }
  }
  
  return { airport: nearest, distance: minDistance };
}

export function calculateTravelSurcharge(distanceInMiles: number): number {
  // Base travel fee included in pricing up to 50 miles
  if (distanceInMiles <= 50) return 0;
  
  // $100 per 50 miles beyond the first 50
  const extraMiles = distanceInMiles - 50;
  const surcharge = Math.ceil(extraMiles / 50) * 100;
  
  return surcharge;
}
